import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  IconButton,
  Alert,
  Button,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  ToggleButtonGroup, 
    CircularProgress,
  ToggleButton,

} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import {
  getolumler,
  deleteDeath,
  deleteEntDeath,
  getSuTuketimi,
  deleteSuTuketimi,
  getEntBaitList,
  postBaitDelete,
  postEntBaitDelete,
  getKiloVerileri,
  deleteKilo,
  getBakiciAtananKumesler,
  deleteBakiciKumesAtama,
  getUreticiBakicilari,
  postBakiciAtama,
  getKumeseBakicilar,
  getZiyaretler,

   getAsilamalar, getEntDonemIlacBilgiler
} from "../../services/api";

const ORANGE = "#FF7A2B";

export default function DetailCards({
  donemId,
  kumesId,
  ureticiId,
  isIntegrated,
  canEdit,
  onOpenOlum,
  onOpenSu,
  onOpenYem,
  onOpenKilo,
  onEditSu,
  // ✅ Refresh counter'lar (Page'den gelir)
  olumRefresh,
  suRefresh,
  yemRefresh,
  kiloRefresh,
  ziyaretRefresh,
  asilamaRefresh,
  ilacRefresh,
  // ✅ Silme/güncelleme sonrası Page'i haberdar et
  onOlumChanged,
  onSuChanged,
  onYemChanged,
  onKiloChanged,
  onZiyaretChanged,
  onAsilamaChanged,
  onIlacChanged,
}) {
  const [olumVerileri, setOlumVerileri] = useState([]);
  const [olumLoading, setOlumLoading] = useState(false);
  const [olumError, setOlumError] = useState([""]);
  const [suVerileri, setSuVerileri] = useState([]);
  const [suLoading, setSuLoading] = useState(false);
  const [suError, setSuError] = useState([""]);
  const [yemVerileri, setYemVerileri] = useState([]);
  const [yemLoading, setYemLoading] = useState(false);
  const [yemError, setYemError] = useState([""]);
  const [kiloVerileri, setKiloVerileri] = useState([]);
  const [kiloLoading, setKiloLoading] = useState(false);
  const [kiloError, setKiloError] = useState([""]);
  const [atananBakicilar, setAtananBakicilar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [kumesBakicilar, setKumesBakicilar] = useState([]); // ✅ EKLE
  const [kumesBakicilarLoading, setKumesBakicilarLoading] = useState(false); // ✅ EKLE
  const [kumesBakicilarError, setKumesBakicilarError] = useState(""); // ✅ EKLE
  const [kisiTab, setKisiTab] = useState("bakici");
 const [ziyaretler, setZiyaretler] = useState([]);
const [ziyaretlerLoading, setZiyaretlerLoading] = useState(false);
const [ziyaretlerError, setZiyaretlerError] = useState("");
const [ilacTab, setIlacTab] = useState("asilama"); // asilama | ilac

const [asilamalar, setAsilamalar] = useState([]);
const [asilmalarLoading, setAsilamalarLoading] = useState(false);
const [asilamalarError, setAsilamalarError] = useState("");

const [ilaclar, setIlaclar] = useState([]);
const [ilaclarLoading, setIlaclarLoading] = useState(false);
const [ilaclarError, setIlaclarError] = useState("");

const [asilamaDetayOpen, setAsilamaDetayOpen] = useState(false);
const [selectedAsilama, setSelectedAsilama] = useState(null);

const [ziyaretDetayOpen, setZiyaretDetayOpen] = useState(false);
const [selectedZiyaret, setSelectedZiyaret] = useState(null);

const [bakiciRefresh, setBakiciRefresh] = useState(0); // ✅ EKLE
const [deletingOlumId, setDeletingOlumId] = useState(null);

const [oncekiSuVeriListesi, setOncekiSuVeriListesi] = useState([]);




const closeZiyaretDetay = () => {
  setZiyaretDetayOpen(false);
  setSelectedZiyaret(null);
};

  // ✅ Bakıcı Atama Dialog
  const [bakiciAtamaModalOpen, setBakiciAtamaModalOpen] = useState(false);
  const [tumBakicilar, setTumBakicilar] = useState([]);
  const [secilenBakiciIdler, setSecilenBakiciIdler] = useState([]); // ✅ ARRAY'E ÇEVIR
  const [atamaBakiciLoading, setAtamaBakiciLoading] = useState(false);


  const atanmisBakiciIdSet = useMemo(() => {
  return new Set(
    (kumesBakicilar || []).map((b) => Number(b.BAKICI_KULLANICI_ID))
  );
}, [kumesBakicilar]);



    const toplamOlum = useMemo(() => {
      return (olumVerileri || []).reduce((sum, item) => {
        return sum + Number(item?.OLUM_SAYISI || 0);
      }, 0);
    }, [olumVerileri]);
  


  
  const fetchOlumVerileri = async () => {
        try {
          setOlumLoading(true);
          const response = await getolumler(donemId);
          setOlumVerileri(response.data.data);
          console.log("✅ Ölüm verileri yüklendi:", response.data.data);
        } catch (err) {
          setOlumError(err.response?.data?.message || "Bir hata oluştu");
        } finally {
          setOlumLoading(false);
    }
  };

  const fetchSuVerileri = async () => {
        try {
          setSuLoading(true);
          const response = await getSuTuketimi(donemId);
          setSuVerileri(response.data.data);
          console.log("✅ Su verileri yüklendi:", response.data.data);

        } catch (err) {
          setSuError(err.response?.data?.message || "Bir hata oluştu");
        } finally {
          setSuLoading(false);
    }
  };

  const fetchYemVerileri = async () => {
        try {
          setYemLoading(true);
          const response = await getEntBaitList(donemId);
          setYemVerileri(response.data.data);
          console.log("✅ Yem verileri yüklendi:", response.data.data); 
        } catch (err) {
          setYemError(err.response?.data?.message || "Bir hata oluştu");
        } finally {
          setYemLoading(false);
    }
  };

const fetchKiloVerileri = async () => {
  try {
    setKiloLoading(true);
    setKiloError("");
    const res = await getKiloVerileri(donemId);

    const data = Array.isArray(res?.data?.data) ? res.data.data : [];
    setKiloVerileri(data);

    console.log("✅ Kilo verileri yüklendi:", data);
  } catch (err) {
    setKiloError(err?.response?.data?.message || "Kilo verileri alınamadı");
  } finally {
    setKiloLoading(false);
  }
};

useEffect(() => {
  if (!donemId) return;
  fetchKiloVerileri();
}, [donemId, kiloRefresh]);

  
  const fetchBakicilar = async () => {
        try {
          setKumesBakicilarLoading(true);
          const response = await getKumeseBakicilar(kumesId);
          setKumesBakicilar(response.data.data);
          console.log("✅ Kümes bakıcıları yüklendi:", response.data.data);
        } catch (err) {
          setKumesBakicilarError(err.response?.data?.message || "Bir hata oluştu");
        } finally {
          setKumesBakicilarLoading(false);
    }
  }

  const fetchZiyaretler = async () => {
        try {
          setZiyaretlerLoading(true);
          const response = await getZiyaretler(donemId);
          setZiyaretler(response.data.data);
          console.log("✅ Ziyaretler yüklendi:", response.data.data);
        } catch (err) {
          setZiyaretlerError(err.response?.data?.message || "Bir hata oluştu");
        } finally {
          setZiyaretlerLoading(false);
    }
  }
  const fetchAsilamalar = async () => {
  try {
    setAsilamalarLoading(true);
    setAsilamalarError("");
    const res = await getAsilamalar(donemId);
    setAsilamalar(Array.isArray(res?.data?.data) ? res.data.data : []);
  } catch (err) {
    setAsilamalarError(err.response?.data?.message || "Bir hata oluştu");
  } finally {
    setAsilamalarLoading(false);
  }
};

const fetchIlaclar = async () => {
  try {
    setIlaclarLoading(true);
    setIlaclarError("");
    const res = await getEntDonemIlacBilgiler(donemId);
    setIlaclar(Array.isArray(res?.data?.data) ? res.data.data : []);
  } catch (err) {
    setIlaclarError(err.response?.data?.message || "Bir hata oluştu");
  } finally {
    setIlaclarLoading(false);
  }
};

useEffect(() => {
  if (!donemId) return;
  fetchOlumVerileri();
}, [donemId, olumRefresh]);

useEffect(() => {
  if (!donemId) return;
  fetchSuVerileri();
}, [donemId, suRefresh]);

useEffect(() => {
  if (!donemId) return;
  fetchYemVerileri();
}, [donemId, yemRefresh]);

useEffect(() => {
  if (!donemId) return;
  fetchKiloVerileri();
}, [donemId, kiloRefresh]);

useEffect(() => {
  if (!kumesId) return;
  fetchBakicilar();
}, [kumesId, bakiciRefresh]);

useEffect(() => {
  if (!donemId) return;
  fetchZiyaretler();
}, [donemId, ziyaretRefresh]);

useEffect(() => {
  if (!donemId) return;
  fetchAsilamalar();
}, [donemId, asilamaRefresh]);

useEffect(() => {
  if (!donemId) return;
  fetchIlaclar();
}, [donemId, ilacRefresh]);


   

  
  // ✅ Bakıcı seçimi toggle et
const handleBakiciToggle = (bakiciId) => {
  const numericId = Number(bakiciId);

  if (atanmisBakiciIdSet.has(numericId)) {
    return;
  }

  setSecilenBakiciIdler((prev) =>
    prev.includes(numericId)
      ? prev.filter((id) => id !== numericId)
      : [...prev, numericId]
  );
};

  // ✅ Bakıcı Ata
// ✅ Bakıcı Ata
const handleConfirmBakiciAtama = async () => {
  if (secilenBakiciIdler.length === 0 || !kumesId) {
    setError("Bakıcı seçiniz");
    return;
  }

  if (!ureticiId) {
    setError("Üretici ID bulunamadı");
    return;
  }

  try {
    setAtamaBakiciLoading(true);
    setError("");

    for (const bakiciId of secilenBakiciIdler) {
      const payload = {
        URETICI_ID: Number(ureticiId),
        KUMES_ID: Number(kumesId),
        BAKICI_KULLANICI_ID: Number(bakiciId),
      };

      await postBakiciAtama(payload);
    }

    const res = await getKumeseBakicilar(kumesId);
    const data = Array.isArray(res?.data?.data) ? res.data.data : [];
    setKumesBakicilar(data);

    setBakiciAtamaModalOpen(false);
    setSecilenBakiciIdler([]);
    setBakiciRefresh((prev) => prev + 1);

    console.log("✅ Bakıcı atama işlemi tamamlandı");
  } catch (err) {
    const errMsg =
      err?.response?.data?.Error ||
      err?.response?.data?.message ||
      err?.response?.data?.data ||
      err?.message ||
      "Bakıcı atanamadı";

    setError(errMsg);
    console.error("❌ Bakıcı atama hatası:", err?.response?.data || err?.message);
  } finally {
    setAtamaBakiciLoading(false);
  }
};

  // ✅ Ölüm Sil
const handleDeleteOlum = async (id) => {
  try {
    setDeletingOlumId(id);

    if (isIntegrated) {
      await deleteEntDeath(id);
    } else {
      await deleteDeath(id);
    }

    setOlumVerileri((prev) => prev.filter((o) => o.DONEM_OLUM_ID !== id));
    onOlumChanged?.();
  } catch (err) {
    setOlumError(err?.response?.data?.message || "Ölüm silinemedi");
  } finally {
    setDeletingOlumId(null);
  }
};

  // ✅ Su Sil
  const handleDeleteSu = async (id) => {
    try {
      await deleteSuTuketimi(id);
      setSuVerileri((prev) => prev.filter((s) => s.DONEM_SU_TUKETIM_ID !== id));
      onSuChanged?.(); // ✅ Page üst alanını güncelle
    } catch (err) {
      setSuError(err?.response?.data?.message || "Su silinemedi");
    }
  };

  // ✅ Yem Sil
  const handleDeleteYem = async (id) => {
    console.log("🗑️ Yem silme isteği, id:", id, "isIntegrated:", isIntegrated)
    ;
    try {
       await postEntBaitDelete({ id });
      setYemVerileri((prev) => prev.filter((y) => y.ID !== id));
      onYemChanged?.(); // ✅ Page üst alanını güncelle
    } catch (err) {
      setYemError(err?.response?.data?.message || "Yem silinemedi");
    }
  };

  // ✅ Kilo Sil
const handleDeleteKilo = async (id) => {
  try {
    await deleteKilo(id);
    setKiloVerileri((prev) => prev.filter((k) => k.DONEM_KILO_ID !== id));
    onKiloChanged?.(); // ✅ Page üst alanını güncelle
  } catch (err) {
    setKiloError(err?.response?.data?.message || "Kilo silinemedi");
  }
};

  // ✅ Bakıcı Atama Modal Açıldığında Tüm Bakıcıları Yükle
const handleOpenBakiciAtama = async () => {
  try {
    setAtamaBakiciLoading(true);
    setError("");
    setSecilenBakiciIdler([]);

    if (!ureticiId) {
      setError("Üretici ID bulunamadı");
      return;
    }

    const [tumBakicilarRes, atananBakicilarRes] = await Promise.all([
      getUreticiBakicilari(ureticiId),
      getKumeseBakicilar(kumesId),
    ]);

    const bakiciListesi = Array.isArray(tumBakicilarRes?.data?.data)
      ? tumBakicilarRes.data.data
      : [];

    const atananlar = Array.isArray(atananBakicilarRes?.data?.data)
      ? atananBakicilarRes.data.data
      : [];

    setTumBakicilar(bakiciListesi);
    setKumesBakicilar(atananlar);
    setBakiciAtamaModalOpen(true);

    console.log("✅ Tüm bakıcılar:", bakiciListesi);
    console.log("✅ Atanmış bakıcılar:", atananlar);
  } catch (err) {
    const errMsg =
      err?.response?.data?.Error ||
      err?.response?.data?.message ||
      err?.response?.data?.data ||
      err?.message ||
      "Bakıcılar yüklenemedi";

    console.error("❌ Bakıcılar yükleme hatası:", err?.response?.data || err?.message);
    setError(errMsg);
  } finally {
    setAtamaBakiciLoading(false);
  }
};

  // ✅ Tarih formatlama
const formatDate = (zaman) => {
  if (!zaman) return "-";
  if (typeof zaman === "string") return zaman;
  const { year, month, day } = zaman;
  return `${String(day).padStart(2, "0")}.${String(month).padStart(2, "0")}.${year}`;
};



  // ✅ Bakıcı Çıkar
  const handleDeleteBakici = async (bakici, kumesAtamaId, bakiciAdi) => {
    if (!kumesAtamaId) {
      setError("Atama ID bulunamadı");
      return;
    }

    const confirmed = window.confirm(
      `${bakiciAdi} adlı bakıcıyı bu kümesinden çıkarmak istediğinize emin misiniz?`
    );

    if (!confirmed) return;

    try {
      console.log("🗑️ Bakıcı ataması siliniyor:", kumesAtamaId);
      
      await deleteBakiciKumesAtama(kumesAtamaId);
      
      setKumesBakicilar(
        kumesBakicilar.filter((b) => b.KUMES_BAKICI_ES_ID !== kumesAtamaId)
      );
      setBakiciRefresh((prev) => prev + 1); // ✅ SADECE BAKICI
    } catch (err) {
      const errMsg = err?.response?.data?.message || err?.response?.data?.data || err?.message;
      setError(errMsg || "Bakıcı çıkarılamadı");
      console.error("❌ Bakıcı silme hatası:", errMsg);
    } finally {
      setBakiciRefresh((prev) => prev + 1);
    }   
  };

  // ✅ Atanan Bakıcılar Yükle
  useEffect(() => {
    if (!kumesId) return;
    setLoading(true);
    getBakiciAtananKumesler(kumesId)
      .then((res) => {
        const data = Array.isArray(res?.data?.data) ? res.data.data : [];
        setAtananBakicilar(data);
      })
      .catch((err) => {
        console.error("❌ Bakıcı verileri hatası:", err);
        setAtananBakicilar([]);
      })
      .finally(() => setLoading(false));
  }, [kumesId, bakiciRefresh]);

  return (
    <Box
    sx={{
      mt: 4,
      width: "100%",
      minWidth: 0,
      overflowX: "hidden",
    }}
  >
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {/* ÖLÜM VERİLERİ - SU VERİLERİ */}
                <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, minmax(0, 1fr))",
              },
              gap: 2,
              mb: 3,
              width: "100%",
              minWidth: 0,
            }}
          >
        {/* ÖLÜM VERİLERİ */}
        <Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 18,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              🔴 Ölüm Verileri
            </Typography>

            <Chip
              size="small"
              label={`Toplam: ${toplamOlum} adet`}
              sx={{
                fontWeight: 800,
                bgcolor: "rgba(239, 68, 68, 0.10)",
                color: "#DC2626",
                border: "1px solid rgba(239, 68, 68, 0.18)",
              }}
            />
          </Stack>

          <IconButton
            size="small"
            sx={{ bgcolor: ORANGE, color: "#fff" }}
            onClick={onOpenOlum}
            disabled={!canEdit}
          >
            <AddIcon />
          </IconButton>
        </Stack>

          <Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
            {olumVerileri.length === 0 ? (
              <Typography sx={{ color: "#9CA3AF", fontSize: 14 }}>Ölüm Verisi Yok</Typography>
            ) : (
              olumVerileri.map((olum) => (
                <Box
                  key={olum.DONEM_OLUM_ID}
                  sx={{
                    p: 1.5,
                    bgcolor: "#F9FAFB",
                    borderRadius: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 400, fontSize: 16 }}>
                      {olum.OLUM_SAYISI} adet
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                      {olum.ZAMAN_STR || "-"}
                    </Typography>
                  </Box>
<Box sx={{ minWidth: 64, display: "flex", justifyContent: "flex-end" }}>
  {deletingOlumId === olum.DONEM_OLUM_ID ? (
    <Stack direction="row" alignItems="center" spacing={1}>
      <CircularProgress size={16} sx={{ color: "#EF4444" }} />
      <Typography sx={{ fontSize: 12, color: "#EF4444", fontWeight: 700 }}>
        Siliniyor...
      </Typography>
    </Stack>
  ) : (
    <IconButton
      size="small"
      disabled={!canEdit}
      onClick={() => handleDeleteOlum(olum.DONEM_OLUM_ID)}
    >
      <DeleteIcon sx={{ fontSize: 18, color: "#EF4444" }} />
    </IconButton>
  )}
</Box>
                </Box>
              ))
            )}
          </Stack>
        </Paper>

        {/* SU VERİLERİ */}
        <Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 900, fontSize: 18, display: "flex", alignItems: "center", gap: 1 }}>
              💧 Su Verileri
            </Typography>
            <IconButton size="small" sx={{ bgcolor: ORANGE, color: "#fff" }} onClick={onOpenSu} disabled={!canEdit}>
              <AddIcon />
            </IconButton>
          </Stack>

          <Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
            {suVerileri.length === 0 ? (
              <Typography sx={{ color: "#9CA3AF", fontSize: 14 }}>Su Verisi Yok</Typography>
            ) : (
              suVerileri.map((su, index) => {
                const sayac = Number(su?.SAYAC_DEGERI || 0);

                // Bir önceki kayıt, ekranda bunun altındaki kayıt
                const oncekiSu = index < suVerileri.length - 1 ? suVerileri[index + 1] : null;
                const oncekiSayac = Number(oncekiSu?.SAYAC_DEGERI || 0);

                const ilkKayit = index === suVerileri.length - 1;
                const sonKullanim = ilkKayit ? 0 : Math.max(sayac - oncekiSayac, 0);

                return (
                  <Box
                    key={su.DONEM_SU_TUKETIM_ID}
                    sx={{
                      p: 1.5,
                      bgcolor: "#F9FAFB",
                      borderRadius: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontWeight: 400, fontSize: 16 }}>
                        {ilkKayit ? `${sayac} m³` : `${sonKullanim} m³`}{" Tüketim "}
                      </Typography>


                      <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                        {formatDate(su.ZAMAN)} • {su.KULLANICI_ADI_SOYADI}
                      </Typography>

                      <Typography sx={{ fontSize: 12, color: "#6B7280",  }}>
                        {ilkKayit
                          ? "İlk sayaç kaydı"
                          : `Sayaç: ${sayac} m³    -->    (Bir önceki sayaç: ${oncekiSayac} m³)`}
                      </Typography>
                    </Box>

                    <Stack direction="row" spacing={0.5}>
                      <IconButton
                        size="small"
                        onClick={() => onEditSu(su)}
                        disabled={!canEdit}
                      >
                        <EditIcon sx={{ fontSize: 18, color: ORANGE }} />
                      </IconButton>

                      <IconButton
                        size="small"
                        onClick={() => handleDeleteSu(su.DONEM_SU_TUKETIM_ID)}
                        disabled={!canEdit}
                      >
                        <DeleteIcon sx={{ fontSize: 18, color: "#EF4444" }} />
                      </IconButton>
                    </Stack>
                  </Box>
                );
              })
            )}
          </Stack>
        </Paper>
      </Box>

      {/* YEM VERİLERİ - CANLI AĞIRLIK */}
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mb: 3 }}>
        {/* YEM VERİLERİ */}
        <Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 900, fontSize: 18, display: "flex", alignItems: "center", gap: 1 }}>
              🌾 Yem Verileri
            </Typography>
            <IconButton size="small" sx={{ bgcolor: ORANGE, color: "#fff" }} onClick={onOpenYem} disabled={!canEdit}>
              <AddIcon />
            </IconButton>
          </Stack>

          <Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
            {yemVerileri.length === 0 ? (
              <Typography sx={{ color: "#9CA3AF", fontSize: 14 }}>Yem Verisi Yok</Typography>
            ) : (
              yemVerileri.map((yem) => (
                <Box
                  key={yem.DONEM_YEM_TUKETIM_ID}
                  sx={{
                    p: 1.5,
                    bgcolor: "#F9FAFB",
                    borderRadius: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                      <Typography sx={{ fontWeight: 600, fontSize: 18 }}>
                      {yem.TANIM_YEM_TIP_ADI}
                    </Typography>
                    <Typography sx={{ fontWeight: 400, fontSize: 16 }}>
                      {yem.SIPARIS_MIKTARI} kg
                    </Typography>
                    {/* <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                      {yem.TARIH_STR || "-"}
                    </Typography> */}
                  </Box>
                  <IconButton size="small" onClick={() => handleDeleteYem(yem.YEM_TALEP_ID)} disabled={!canEdit}>
                    <DeleteIcon sx={{ fontSize: 18, color: "#EF4444" }} />
                  </IconButton>
                </Box>
              ))
            )}
          </Stack>
        </Paper>

        {/* CANLI AĞIRLIK */}
<Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
    <Typography sx={{ fontWeight: 900, fontSize: 18, display: "flex", alignItems: "center", gap: 1 }}>
      ⚖️ Canlı Ağırlık
    </Typography>
    <IconButton size="small" sx={{ bgcolor: ORANGE, color: "#fff" }} onClick={onOpenKilo} disabled={!canEdit}>
      <AddIcon />
    </IconButton>
  </Stack>

  {kiloError && <Alert severity="error" sx={{ mb: 1.5 }}>{kiloError}</Alert>}

  <Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
    {kiloLoading ? (
      <Typography sx={{ color: "#6B7280", textAlign: "center", py: 4 }}>
        Yükleniyor...
      </Typography>
    ) : kiloVerileri.length === 0 ? (
      <Typography sx={{ color: "#9CA3AF", fontSize: 14 }}>Canlı Ağırlık Verisi Yok</Typography>
    ) : (
      kiloVerileri.map((kilo) => (
        <Box
          key={kilo.DONEM_KILO_ID}
          sx={{
            p: 1.5,
            bgcolor: "#F9FAFB",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography sx={{ fontWeight: 400, fontSize: 16 }}>
              {/* API: OLCULEN_GRAM (örnekte 3) */}
              {kilo.OLCULEN_GRAM} {" "}kg
            </Typography>

            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
              {formatDate(kilo.ZAMAN)} • {kilo.KULLANICI_ADI_SOYADI || "-"} • {kilo.OLCUM_TIPI || "-"}
            </Typography>
          </Box>

          <IconButton size="small" onClick={() => handleDeleteKilo(kilo.DONEM_KILO_ID)} disabled={!canEdit}>
            <DeleteIcon sx={{ fontSize: 18, color: "#EF4444" }} />
          </IconButton>
        </Box>
      ))
    )}
  </Stack>
</Paper>
      </Box>

      {/* BAKICILAR - TAKVİYE İLAÇLAR */}
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
<Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
  {/* ✅ Sekmeler */}
  <ToggleButtonGroup
    exclusive
    fullWidth
    value={kisiTab}
    onChange={(_, v) => v && setKisiTab(v)}
    sx={{
      width: "100%",
      bgcolor: "#F3F4F6",
      p: 0.5,
      borderRadius: 999,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 0.5,
      mb: 2,
      "& .MuiToggleButton-root": {
        border: "none",
        borderRadius: 999,
        py: 0.7,
        fontSize: 12,
        fontWeight: 800,
        color: "#6B7280",
        textTransform: "none",
      },
      "& .Mui-selected": {
        bgcolor: "#fff !important",
        color: "#111827",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      },
    }}
  >
    <ToggleButton value="bakici">Bakıcılar</ToggleButton>
    <ToggleButton value="veteriner">Veteriner Ziyaretleri</ToggleButton>
  </ToggleButtonGroup>

  {/* İçerik: sekmeye göre */}
  {kisiTab === "bakici" ? (
    
    <Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>


    {/* Ekle butonu sekmeye göre değişsin */}
    <Button 
    
      variant="contained"
      size="small"
      startIcon={<AddIcon />}
      sx={{
        bgcolor: ORANGE,
        color: "#fff",
        textTransform: "none",
        fontWeight: 700,
        fontSize: "0.875rem",
        
      }}
      disabled={!canEdit}
      onClick={() => {
        if (kisiTab === "bakici") handleOpenBakiciAtama();
        else {
          // şimdilik boş bırak, veteriner modalın/ekleme aksiyonun yoksa:
          setError("Veteriner ekleme henüz bağlı değil");
        }
      }}
    >
      Ekle
    </Button>
  </Stack>
      {kumesBakicilar.length === 0 ? (
        <Typography sx={{ color: "#9CA3AF", fontSize: 14, textAlign: "center", py: 4 }}>
          Bakıcı atanmamış
        </Typography>
      ) : (
        kumesBakicilar.map((bakici) => (
          <Box
            key={bakici.KUMES_BAKICI_ES_ID}
            sx={{
              p: 2,
              bgcolor: "#F9FAFB",
              borderRadius: 1.5,
              border: "1px solid #E5E7EB",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, flex: 1 }}>
              <Avatar
                sx={{
                  width: 45,
                  height: 45,
                  bgcolor: ORANGE,
                  fontWeight: 700,
                  fontSize: "1.1rem",
                }}
              >
                {(bakici.BAKICI_ADI?.[0] || "B").toUpperCase()}
              </Avatar>

              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontWeight: 800, fontSize: 15 }}>
                  {bakici.BAKICI_ADI} {bakici.BAKICI_SOYADI}
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.5 }}>
                  {bakici.BAKICI_TEL || "Tel: -"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1 }}>
              <Chip
                label="Aktif"
                size="small"
                sx={{
                  bgcolor: "#DBEAFE",
                  color: "#1D4ED8",
                  fontWeight: 700,
                  fontSize: "0.75rem",
                }}
              />
              <IconButton
                size="small"
                onClick={() =>
                  handleDeleteBakici(
                    bakici,
                    bakici.KUMES_BAKICI_ES_ID,
                    `${bakici.BAKICI_ADI} ${bakici.BAKICI_SOYADI}`
                  )
                }
                disabled={!canEdit}
                sx={{ color: "#EF4444", "&:hover": { bgcolor: "#FEE2E2" } }}
              >
                <DeleteIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Box>
        ))
      )}
    </Stack>
    
  ) : (
    
<Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
  {ziyaretlerLoading ? (
    <Typography sx={{ color: "#6B7280", textAlign: "center", py: 4 }}>
      Yükleniyor...
    </Typography>
  ) : ziyaretlerError ? (
    <Typography sx={{ color: "#DC2626", textAlign: "center", py: 4 }}>
      {ziyaretlerError}
    </Typography>
  ) : ziyaretler.length === 0 ? (
    <Typography sx={{ color: "#9CA3AF", fontSize: 14, textAlign: "center", py: 4 }}>
      Veteriner ziyareti kaydı bulunmamaktadır.
    </Typography>
  ) : (
    ziyaretler.map((z, idx) => (
      <Box
        key={z.DONEM_ZIYARET_ID ?? idx}
        sx={{
          p: 2,
          bgcolor: "#F9FAFB",
          borderRadius: 1.5,
          border: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontWeight: 900, fontSize: 14 }}>
            {z.VETERINERLIK_ADI || "-"}
          </Typography>

          <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.25 }}>
            {z.ZAMAN_STR || "-"}
          </Typography>

          <Typography
            sx={{
              fontSize: 12,
              color: "#6B7280",
              mt: 0.75,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",
            }}
            title={z.VETERINER_NOTU || ""}
          >
            {z.VETERINER_NOTU || "Not yok"}
          </Typography>
        </Box>

        <Button
          size="small"
          variant="outlined"
          onClick={() => {
            setSelectedZiyaret(z);
            setZiyaretDetayOpen(true);
          }}
          sx={{
            borderColor: "#E5E7EB",
            color: "#111827",
            textTransform: "none",
            fontWeight: 800,
            borderRadius: 2,
            "&:hover": { borderColor: ORANGE, bgcolor: "#FFF7ED" },
            flexShrink: 0,
          }}
        >
          Detay
        </Button>
      </Box>
    ))
  )}
</Stack>
  )}
</Paper>

        {/* TAKVİYE İLAÇLAR */}
<Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: "#fff" }}>
  {/* PILL SEKME */}
  <ToggleButtonGroup
    exclusive
    fullWidth
    value={ilacTab}
    onChange={(_, v) => v && setIlacTab(v)}
    sx={{
      width: "100%",
      bgcolor: "#F3F4F6",
      p: 0.5,
      borderRadius: 999,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 0.5,
      mb: 2,
      "& .MuiToggleButton-root": {
        border: "none",
        borderRadius: 999,
        py: 0.7,
        fontSize: 12,
        fontWeight: 800,
        color: "#6B7280",
        textTransform: "none",
      },
      "& .Mui-selected": {
        bgcolor: "#fff !important",
        color: "#111827",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      },
    }}
  >
    <ToggleButton value="asilama">Aşılamalar</ToggleButton>
    <ToggleButton value="ilac">Takviye İlaçlar</ToggleButton>
  </ToggleButtonGroup>

  {/* İÇERİK */}
  <Stack spacing={1.5} sx={{ height: 300, overflowY: "auto", pr: 1 }}>
    {ilacTab === "asilama" ? (
      asilmalarLoading ? (
        <Typography>Yükleniyor...</Typography>
      ) : asilamalar.length === 0 ? (
        <Typography sx={{ textAlign: "center", py: 4, color: "#9CA3AF" }}>
          Aşılama verisi yok
        </Typography>
      ) : (
        asilamalar.map((a, idx) => (
          <Box
            key={idx}
            sx={{
              p: 2,
              bgcolor: "#F9FAFB",
              borderRadius: 1.5,
              border: "1px solid #E5E7EB",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: 900, fontSize: 14 }}>
                {a.ASILAMA_ADI}
              </Typography>

              <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                {a.ZAMAN_STR}
              </Typography>

              <Typography
                sx={{
                  fontSize: 12,
                  color: "#6B7280",
                  mt: 0.75,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {a.VETERINER_NOTU || "Not yok"}
              </Typography>
            </Box>

            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setSelectedAsilama(a);
                setAsilamaDetayOpen(true);
              }}
              sx={{
                borderColor: "#E5E7EB",
                color: "#111827",
                textTransform: "none",
                fontWeight: 800,
                borderRadius: 2,
              }}
            >
              Detay
            </Button>
          </Box>
        ))
      )
    ) : (
      ilaclarLoading ? (
        <Typography>Yükleniyor...</Typography>
      ) : ilaclar.length === 0 ? (
        <Typography sx={{ textAlign: "center", py: 4, color: "#9CA3AF" }}>
          Takviye ilaç verisi yok
        </Typography>
      ) : (
        ilaclar.map((i, idx) => (
          <Box
            key={idx}
            sx={{
              p: 2,
              bgcolor: "#F9FAFB",
              borderRadius: 1.5,
              border: "1px solid #E5E7EB",
            }}
          >
            <Typography sx={{ fontWeight: 800 }}>
              {i.ILAC_ADI || "İlaç"}
            </Typography>
            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
              {i.ZAMAN_STR}
            </Typography>
          </Box>
        ))
      )
    )}
  </Stack>
</Paper>
      </Box>
      <Dialog
  open={asilamaDetayOpen}
  onClose={() => {
    setAsilamaDetayOpen(false);
    setSelectedAsilama(null);
  }}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Aşılama Detayı</DialogTitle>
  <DialogContent>
    {selectedAsilama && (
      <Stack spacing={1.5}>
        <Typography><b>Tarih:</b> {selectedAsilama.ZAMAN_STR}</Typography>
        <Typography><b>Aşı:</b> {selectedAsilama.ASILAMA_ADI}</Typography>
        <Typography><b>Genel Toplam:</b> {selectedAsilama.GENEL_TOPLAM ?? "-"}</Typography>
        <Typography><b>Not:</b> {selectedAsilama.VETERINER_NOTU ?? "-"}</Typography>
      </Stack>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setAsilamaDetayOpen(false)}>Kapat</Button>
  </DialogActions>
</Dialog>


      {/* ✅ BAKICI ATAMA MODAL */}
      <Dialog
        open={bakiciAtamaModalOpen}
        onClose={() => setBakiciAtamaModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: "1.2rem" }}>Bakıcı Ata</DialogTitle>
<DialogContent sx={{ pt: 2 }}>
  <Stack spacing={2}>
    {error && <Alert severity="error">{error}</Alert>}

    {atamaBakiciLoading ? (
      <Typography sx={{ textAlign: "center", color: "#6B7280", py: 3 }}>
        Bakıcılar yükleniyor...
      </Typography>
    ) : (
      <Stack spacing={1}>
        {tumBakicilar.length === 0 ? (
          <Typography sx={{ textAlign: "center", color: "#9CA3AF", py: 3 }}>
            Bakıcı bulunamadı
          </Typography>
        ) : (
          tumBakicilar.map((bakici) => {
            const bakiciId = Number(bakici.BAKICI_KULLANICI_ID);
            const isAssigned = atanmisBakiciIdSet.has(bakiciId);
            const isSelected = secilenBakiciIdler.includes(bakiciId);

            return (
              <Box
                key={bakiciId}
                onClick={() => {
                  if (!isAssigned) {
                    handleBakiciToggle(bakiciId);
                  }
                }}
                sx={{
                  p: 2,
                  border: isSelected
                    ? `2px solid ${ORANGE}`
                    : "1px solid #E5E7EB",
                  borderRadius: 1.5,
                  bgcolor: isAssigned
                    ? "#F3F4F6"
                    : isSelected
                    ? "#FFF7ED"
                    : "#F9FAFB",
                  cursor: isAssigned ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  transition: "all 0.2s",
                  opacity: isAssigned ? 0.7 : 1,
                  "&:hover": {
                    bgcolor: isAssigned ? "#F3F4F6" : "#F3F4F6",
                    borderColor: isAssigned ? "#E5E7EB" : ORANGE,
                  },
                }}
              >
                <Avatar
                  sx={{
                    width: 45,
                    height: 45,
                    bgcolor: isAssigned
                      ? "#D1D5DB"
                      : isSelected
                      ? ORANGE
                      : "#D1D5DB",
                    fontWeight: 700,
                    fontSize: "1.1rem",
                    color: "#fff",
                  }}
                >
                  {(bakici.BAKICI_ADI?.[0] || "B").toUpperCase()}
                </Avatar>

                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 800, fontSize: 14 }}>
                    {bakici.BAKICI_ADI} {bakici.BAKICI_SOYADI}
                  </Typography>

                  <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.5 }}>
                    {bakici.KULLANICI_TEL_NO || "Tel: -"}
                  </Typography>

                  {isAssigned && (
                    <Typography
                      sx={{
                        fontSize: 12,
                        color: "#DC2626",
                        mt: 0.5,
                        fontWeight: 700,
                      }}
                    >
                      Bu bakıcı zaten atanmış
                    </Typography>
                  )}
                </Box>

                {isAssigned ? (
                  <Chip
                    label="Zaten Atanmış"
                    size="small"
                    sx={{
                      bgcolor: "#DBEAFE",
                      color: "#1D4ED8",
                      fontWeight: 700,
                    }}
                  />
                ) : (
                  isSelected && (
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        bgcolor: ORANGE,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontWeight: 800,
                      }}
                    >
                      ✓
                    </Box>
                  )
                )}
              </Box>
            );
          })
        )}
      </Stack>
    )}
  </Stack>
</DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setBakiciAtamaModalOpen(false)}>Vazgeç</Button>
          <Button
            variant="contained"
            onClick={handleConfirmBakiciAtama}
            disabled={secilenBakiciIdler.length === 0 || atamaBakiciLoading} // ✅ ARRAY KONTROL
            sx={{ bgcolor: ORANGE }}
          >
            {atamaBakiciLoading ? "Atanıyor..." : `${secilenBakiciIdler.length} Bakıcıyı Ata`} {/* ✅ SAYAÇ */}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
  open={ziyaretDetayOpen}
  onClose={() => setZiyaretDetayOpen(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle sx={{ fontWeight: 900 }}>
    Veteriner Ziyareti Detayı
  </DialogTitle>

  <DialogContent sx={{ pt: 2 }}>
    {!selectedZiyaret ? (
      <Typography sx={{ color: "#6B7280" }}>Detay bulunamadı</Typography>
    ) : (
      <Stack spacing={1.25}>
        <Box>
          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Dönem</Typography>
          <Typography sx={{ fontWeight: 800 }}>{selectedZiyaret.DONEM_ADI || "-"}</Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Tarih</Typography>
          <Typography sx={{ fontWeight: 800 }}>{selectedZiyaret.ZAMAN_STR || "-"}</Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Veterinerlik</Typography>
          <Typography sx={{ fontWeight: 800 }}>{selectedZiyaret.VETERINERLIK_ADI || "-"}</Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Ziyaret Günü Ağırlık</Typography>
          <Typography sx={{ fontWeight: 800 }}>
            {selectedZiyaret.ZIYARET_GUN_AGIRLIK_GR != null
              ? `${selectedZiyaret.ZIYARET_GUN_AGIRLIK_GR} gr`
              : "-"}
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Genel Toplam</Typography>
          <Typography sx={{ fontWeight: 800 }}>
            {selectedZiyaret.GENEL_TOPLAM != null ? selectedZiyaret.GENEL_TOPLAM : "-"}
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Not</Typography>
          <Typography sx={{ fontWeight: 700, whiteSpace: "pre-wrap" }}>
            {selectedZiyaret.VETERINER_NOTU || "Not yok"}
          </Typography>
        </Box>
      </Stack>
    )}
  </DialogContent>

  <DialogActions sx={{ p: 2 }}>
    <Button onClick={() => setZiyaretDetayOpen(false)}>Kapat</Button>
  </DialogActions>
</Dialog>

    </Box>
  );
}